import { Theme } from '../constants';

export default {
    inputContainer: {
        display: "flex",
        borderBottom: "1px solid #262626",
    },
    textInput: {
        border: "none",
        backgroundColor: "inherit",
        outline: "none",
        width: "100%",
        paddingBottom: "6px",
        fontFamily: "Lato",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "16px",
        color: Theme.TEXT_PRIMARY_BLACK
    },
    errorText: {
        fontSize: "16px",
        lineHeight: "20px",
        color: Theme.ERROR_TEXT,
    },
    disabledInput: {
        background: "#f7fe3f"
    },
    errorTooltip: {
        background: "#F4ABAB",
    },
    formFieldWrapper: {
        display: "flex",
        width : "100%"
    },
    formField:{
        flex: 1
    },
    optionsModalCustomPopup: {
        borderRadius: "0px",
        maxWidth: "unset",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
    optionsModalOverlayStyles: {
        background: "transparent",
        position: "fixed",
        top: "calc(50% + 36px)",
        left: "calc(50% + 40px)",
        transform: "translate(-50%, -50%)",
        transition: "all 0.5s ease-in-out 0s",
        width: "calc(100vw - 78px)",
        height: "calc(100vh - 72px)",
        zIndex: 1000,
    },
    optionsModalChildrenStyles: {
        maxHeight: "unset",
        height: "100%",
        overflowY: "auto",
        display: "flex",
    },
    helpTextIconStyle: {
        cursor: "pointer",
    },
    multiSelectEnumSingleOptionCustomStyles: {
        alignItems: "flex-start",
    },
};
